import {isNil} from 'ramda';

import {useGetParticipationQuery} from '@dms/api/core';
import {useGetVehicleQuery} from '@dms/api/sales';
import {EntityResourceIds} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {usePermissions} from './usePermissions/usePermissions';

interface VehiclePhotosPermissions {
  vehicleId: string | Nullish;
}

export function useVehiclePhotosPermissions(props: VehiclePhotosPermissions) {
  const {data: vehicleParticipation} = useGetParticipationQuery(
    {
      resourceId: EntityResourceIds.vehicle,
      recordId: props.vehicleId ?? '',
    },
    {skip: isNil(props.vehicleId)}
  );

  const {data: vehicle} = useGetVehicleQuery(
    {vehicleId: props.vehicleId ?? ''},
    {skip: isNil(props.vehicleId)}
  );

  const [canReadVehicleAlbumPhotos] = usePermissions({
    permissionKeys: ['readVehicleAlbumPhotos'],
    scopes: {
      readVehicleAlbumPhotos: {
        participation: vehicleParticipation,
        branchId: vehicle?.branchId,
      },
    },
  });

  const permissionsMap = {
    canReadVehicleAlbumPhotos,
  } as const;

  return permissionsMap;
}
